"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TabStyle = exports.Tab = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _recompose = require("recompose");
var _classnames = _interopRequireDefault(require("classnames"));
var _colors = require("../../style/colors");
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _excluded = ["children", "classes", "className", "colorScheme", "component", "tabClassName", "theme"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*:: // 

import { type ElementType } from 'react';*/
/*:: import type {
  InjectSheetProvidedProps,
  ThemeType
} from '../../style/ThemeTypes';*/
var TabStyle = exports.TabStyle = function TabStyle(theme /*: ThemeType*/) {
  var ACTIVE_BORDER_WIDTH = '2px';
  var keys = Object.keys(_colors.COLORS);
  return {
    root: {
      flex: 'none',
      '& + $root': {
        marginLeft: '2rem'
      }
    },
    tab: _objectSpread(_objectSpread({}, theme.typography.extraSmallText), {}, {
      display: 'block',
      padding: '1rem 0',
      color: theme.colors.pebbleGrey,
      textTransform: 'uppercase',
      letterSpacing: '1px',
      cursor: 'pointer',
      '&:active, &:hover': {
        color: theme.colors.pebbleGrey,
        opacity: 1
      },
      '&[aria-selected="true"], &[aria-current="page"]': {
        borderBottom: "".concat(ACTIVE_BORDER_WIDTH, " solid ").concat(theme.colors.black),
        color: theme.colors.black,
        '&:active, &:hover': {
          color: theme.colors.black,
          opacity: 1
        }
      }
    }),
    colorScheme: keys.reduce(function (accumulator, color) {
      var hex = _colors.COLORS[color];
      return _objectSpread(_objectSpread({}, accumulator), {}, (0, _defineProperty2.default)({}, "&[aria-selected=\"true\"][data-color=\"".concat(color, "\"], &[aria-current=\"page\"][data-color=\"").concat(color, "\"]"), {
        borderBottom: "".concat(ACTIVE_BORDER_WIDTH, " solid ").concat(hex)
      }));
    }, {})
  };
};
/*:: type Props = InjectSheetProvidedProps & {
  children?: string,
  colorScheme?: string,
  component: ElementType,
  tabClassName?: string
};*/
var Tab = exports.Tab = function Tab(props /*: Props*/) {
  var children = props.children,
    classes = props.classes,
    className = props.className,
    _props$colorScheme = props.colorScheme,
    colorScheme = _props$colorScheme === void 0 ? _colors.SCIENCE_BLUE : _props$colorScheme,
    _props$component = props.component,
    Component = _props$component === void 0 ? 'a' : _props$component,
    tabClassName = props.tabClassName,
    theme = props.theme,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  return /*#__PURE__*/_react.default.createElement("li", {
    className: (0, _classnames.default)(classes.root, className),
    role: "presentation"
  }, /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.tab, classes.colorScheme, tabClassName),
    "data-color": colorScheme
  }, other), children));
};
Tab.displayName = 'Tab';
var _default = exports.default = (0, _recompose.compose)((0, _injectSheet.default)(TabStyle))(Tab);
//# sourceMappingURL=Tab.js.map